import { render, staticRenderFns } from "./Vagas.vue?vue&type=template&id=1de9c8f4"
import script from "./Vagas.vue?vue&type=script&lang=js"
export * from "./Vagas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports